<template>
  <BaseCard :card-name="tr('Patient Card')" :spinnerOn="false" v-if="!patientId">
    <div class="no-patient">
      <p>{{ tr('No patient selected') }}</p>
    </div>
  </BaseCard>
  <Suspense v-else>
    <template #default>
      <div class="base-card card-elevated">
        <div class="card-header">
          <div class="card-name patient">{{ patientFullName }}</div>
        </div>
        <PatientSummary />
      </div>
    </template>
    <template #fallback>
      <BaseCard :card-name="tr('Patient Card')" :spinnerOn="true">
        <div class="no-patient">
          <p>{{ tr('Loading patient data.') }}</p>
        </div>
      </BaseCard>
    </template>
  </Suspense>
</template>

<script setup>
// Copyright (c) 2020-2023 dātma, inc™
//
// Unauthorized copying of this file, via any medium is strictly prohibited
// Proprietary and confidential

import PatientSummary from './PatientSummary.vue'
import BaseCard from '@/ux3/cards/BaseCard/BaseCard.vue'
import { computed } from 'vue'
import { useStore } from 'vuex'

const tr = (x) => x // inject('tr')
const store = useStore()

const patientId = computed(() => store.getters.session?.patient?.id || '')
const patientFullName = computed(() => {
  const first = store.getters.session?.patient?.given || ''
  const last = store.getters.session?.patient?.family || ''
  return `${first} ${last}`.trim()
})
</script>

<style lang="scss" scoped>
p {
  margin: auto;
  color: var(--Grey600);
  font-size: 1rem;
}

.no-patient {
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 20px;
}

.search-icon {
  font-size: 100px;
  color: var(--Grey200);

  &:hover {
    color: var(--PrimaryLight);
    cursor: pointer;
  }
}

.search-icon-div {
  margin-top: 3.5vh;
  margin-bottom: 2vh;
}
</style>

<style lang="scss" scoped>
.patient {
  color: var(--Black);
  font-weight: bold;
}

.patients-like-me {
  border-radius: 5px;
  font-size: 55%;
  background-color: var(--Grey100);
  padding: 2%;
  cursor: pointer;
  transition: all linear 200ms;

  &:hover {
    color: var(--Black);
  }
}

.patient-card {
  .card-elevated {
    height: 100%;
  }
}
</style>
